module.exports = __webpack_public_path__ + "images/thumb-c1c86524cc640033cae412f57dc137ac.jpg";